import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type BgTakenPayload = {
  bg: number;
  bg_source?: number;
  iob?: number;
  target_bg?: number;
  isf?: number;
};

export type BgTakenEvent = {
  bg: number;
  bgSource?: number;
  iob?: number;
  targetBg?: number;
  isf?: number;
};

const bgTakenSchema = z.object({
  bg: z.number(),
  bg_source: cz.permissive(z.number()),
  iob: cz.permissive(z.number()),
  target_bg: cz.permissive(z.number()),
  isf: cz.permissive(z.number()),
});

export const LID_BG_READING_TAKEN = {
  value: 0x10,
  name: "BG Taken Event",
  format: "h.bfhh....",
  fields: ["bg", "bg_source", "iob", "target_bg", "isf"],
  postprocess: rec => ({
    bg: rec.bg,
    bgSource: rec.bg_source,
    iob: rec.iob,
    targetBg: rec.target_bg,
    isf: rec.isf,
  }),
  schema: bgTakenSchema,
} as const satisfies TandemEventDefinition<BgTakenPayload, BgTakenEvent>;
